<template>
    <v-dialog width="fit-content" v-model="dialog">
        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                x-small
                icon
                color="grey lighten-1"
                v-on="on"
                @click.stop="dialog = true"
            ><v-icon style="font-size: 20px;">mdi-pencil</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Edit option</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Key*"
                                        hint="enter key"
                                        required
                                        disabled
                                        v-model="okey"
                                        :error-messages="okeyErrors"
                                        @input="$v.okey.$touch()"
                                        @blur="$v.okey.$touch()"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Value*"
                                        hint="enter value"
                                        v-model="ovalue"
                                        :error-messages="ovalueErrors"
                                        required
                                        @input="$v.ovalue.$touch()"
                                        @blur="$v.ovalue.$touch()"
                                ></v-text-field>
                            </v-col>

                        </v-row>

                        <div class="d-flex justify-center">
                            <v-btn
                                    depressed
                                    class="mr-4 primary"
                                    :disabled="this.$v.$invalid || localLoading"
                                    @click="submit"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-check-box-outline</v-icon>
                                Accept Changes
                            </v-btn>
                            <v-btn
                                    class="warning"
                                    depressed
                                    @click="cancel"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                        </div>

                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    // import Vue from 'vue'
    // import * as _ from 'lodash'

    export default {
        mixins: [validationMixin],
        name: "EditOptionModal",
        props: ['thisOptionData'],
        validations: {
            okey: {required},
            ovalue: {required, /* maxLength: maxLength(10)*/},
        },
        data: () => ({
            optionData: null,
            localLoading: false,
            dialog: false,
            okey: '',
            ovalue: '',
        }),
        computed: {
            okeyErrors () {
                const errors = []
                if (!this.$v.okey.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.okey.required && errors.push('First name is required.')
                return errors
            },
            ovalueErrors () {
                const errors = []
                if (!this.$v.ovalue.$dirty) return errors
                !this.$v.ovalue.required && errors.push('Last Name is required.')
                return errors
            },
        },
        created(){
            // --
        },
        mounted()
        {
            this.optionData = this.thisOptionData;
            this.okey = this.thisOptionData.okey;
            this.ovalue = this.thisOptionData.ovalue;
        },
        methods: {
            cancel(){
                this.okey = this.thisOptionData.okey;
                this.ovalue = this.thisOptionData.ovalue;

                this.dialog = false;
            },
            submit () {
                this.localLoading = true;
                this.dialog = true;
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    const option_data = {
                        okey: this.okey,
                        ovalue: this.ovalue,
                    };

                    if (this.switch_change_password) {
                        option_data.password = this.password;
                    }

                    this.$store.dispatch('editOption', option_data).then(() => {
                        this.dialog = false;
                        this.$emit('optionUpdated', '');
                    })
                    .catch(error => {
                        this.email = '';
                        let errors = error.response;
                        this.$store.dispatch('setError', errors[Object.keys(errors)[0]][0]);
                    }).finally(() => {
                        this.localLoading = false;
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>
